
import About from "../components/sections/about/About";
import Services from "../components/sections/services/Services";
import Portfolio from "../components/sections/portfolio/Portfolio";
import Index from "./Index";
import Team from "../components/sections/team/Team";
import Clients from "../components/sections/clients/Clients";
import Testimonials from "../components/sections/testimonials/Testimonials";
import Contact from "../components/sections/contact/Contact";
import Footer from "../components/footer/Footer";
import Faqs from "../components/sections/faqs/Faqs";
import ErrorPage from "../components/sections/Page404/ErrorPage";


export const privateRoute = [
    
    {
        path: "/home",
        element: <Index />,
    },
    {
        path: "/about",
        element: <About />,
    },
    {
        path: "/services",
        element: <Services />,
    },
    {
        path: "/portfolio",
        element: <Portfolio />,
    },
    /* {
        path: "/team",
        element: <Team />,
    }, */
    {
        path: "/clients",
        element: <Clients />,
    },
    {
        path: "/testimonials",
        element: <Testimonials />,
    },
    {
        path: "/faqs",
        element: <Faqs />,
    },
    /* {
        path: "/contact",
        element: <Contact />,
    }, */
    {
        path: "/_",
        element: <Footer />,
    },
    // {
    //     path: "*",
    //     element: <ErrorPage />,
    // },
]

export const privateRouteScroll = [

    
    {
        path: "/",
        element: <Index />,
    },
    

]